export const assetMessage = {
  crossChannelOrRbSiteError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
             'Assets from multiple channels or sites cannot be moved to a Holding Pen at the same time. ' +
             'Please choose only IP Assets or RB assets from the same site.',
    okButtonText: 'OK'
  },
  resellCollapsedAssetError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' This asset is componentized, You must collapse each component individually ' +
    ' as main lots and then re-componentize before selling.',
    okButtonText: 'OK'
  },
  resellNotSoldAssetsError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' Assets with different statuses or in different channels cannot be moved together.',
    okButtonText: 'OK'
  },
  parentComponentsNotSelectedForMoveError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' One or more assets are componentized, to move these assets you must include the parent asset or ' +
    'de-componentize this asset before moving. ',
    okButtonText: 'OK'
  },
  shContractFinalizedMoveError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' Asset cannot be moved from a Contract in "Pending Finalized" or "Finalized", ' +
    'please contact Finance to move the contract back to "In Progress" before making the move. ',
    okButtonText: 'OK'
  },
  shTargetContractFinalizedMoveError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' Asset cannot be moved to a Contract in "Pending Finalized" or "Finalized", please contact Finance to "' +
    'move the contract back to "In Progress" before making the move. ',
    okButtonText: 'OK'
  },
  contractMoveOppWithNoContractError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
      ' This contract is still in the opportunity stage. Either send the contract to operations ' +
      'before making the move or move it to the opportunity. ',
    okButtonText: 'OK'
  },
  assetPreviewOrInAuctionOrSoldStatusMoveError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' One or more selected assets in selling or sold. Please contact Auction Operations to make this move. ',
    okButtonText: 'OK'
  },
  assetMoveOperationalEntityError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' Based on the current selling location, the asset cannot be sold in the selected sale event. ' +
    'Please choose a compatible sale event or selling location. ',
    okButtonText: 'OK'
  },
  reconsignOperationalEntityError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' The asset must be reconsigned to a contract for this sale event. ',
    okButtonText: 'OK'
  },
  assetSoldStatusMoveError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' Only a Senior CSM or Finance person can move a sold asset. ',
    okButtonText: 'OK'
  },
  assetSoldStatusEventEndedMoreThan30DaysError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' Asset was sold more than 30 days ago and can no longer be moved to another contract. ',
    okButtonText: 'OK'
  },
  assetSoldStatusEventEndedMoreThan120DaysError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
      ' Asset was sold more than 120 days ago and can no longer be moved to another contract. ',
    okButtonText: 'OK'
  },
  assetMoveOwnerCodeError: {
    title: 'Could Not Retrieve Owner Codes',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' There was a problem getting Owner Codes from SalesHub, so we could not send these assets to operations. Please' +
      ' try again or contact support for assistance. ',
    okButtonText: 'OK'
  },
  assetMoveNoActionError: {
    title: 'Can\'t be Moved!',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
      'Assets that are closed or abandoned cannot be moved.',
    okButtonText: 'OK'
  },
  assetMoveError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
    ' :message ',
    okButtonText: 'OK'
  },
  reconsignComponentizedAssetWarning: {
    title: '',
    message: '<i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
    ' This asset is componentized, You must reconsign each component individually ' +
    'as main lots and then re-componentize before selling.',
    okButtonText: 'OK'
  },
  parentComponentSelectedForMoveWarning: {
    title: '',
    message: '<i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
    ' One or more assets are componentized and the child assets will be moved as well. If you only want to ' +
    'move the one asset, you must de-componentize the assets first. Do you want to move all assets, press ' +
    '"Continue" to proceed or "Cancel" to return to previous screen',
    width: '640px',
    okButtonText: 'Continue',
    cancelButtonText: 'Cancel'
  },
  budgetsExceededWarning: {
    title: '',
    message: '<i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
    ' R&R and Haulage roll-up is greater than the "Not to Exceed" budget. Please obtain approval from the customer. ',
    okButtonText: 'OK'
  },
  atRiskContractWarning: {
    title: '',
    message:
    ' This asset is being moved off of an At Risk contract. An addendum to the contract is required prior to the sale ',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  atRiskTargetContractWarning: {
    title: '',
    message:
    ' This asset is being moved to an At Risk contract. An addendum to the contract is required prior to the sale ',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  atRiskToAnotherRiskWarning: {
    title: '',
    message:
      ' This asset is being moved from one At risk contract to another. An addendum to the contract is required prior to the sale. ',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  inInspectionOrPresaleWarning: {
    title: '',
    message: '<i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
    ' One or more selected assets are with the Inspection team. Please contact Auction Operations to ' +
    'ensure changes have been made to the IPWeb listing and all costs are transferred. Do you wish to continue? ',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  assetSoldStatusMoveWarning: {
    title: '',
    message: '<i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
    ' This is a sold asset are you sure you want to make this move? ',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  opportunityOrContractDifferentCurrencyWarning: {
    title: "",
    message: '<i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
    ' You are moving assets to an opportunity or contract with a different currency. ' +
    'All sales values for these assets will be lost. Please convert and re-enter the sales values ' +
    "under the contract's default currency. Do you wish to continue? ",
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  assetMoveConfirmation: {
    title: '',
    message: '<i class="fa fa-lg fa-info text-info mr-1 align-middle"></i> ' +
    ' Are you sure you want to make this move? If these assets are in the yard, they may require re-tagging. ',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  assetMoveToContractReadyConfirmation: {
    title: '',
    message: '<i class="fa fa-lg fa-info text-info mr-1 align-middle"></i> ' +
    ' Do you want to send these assets to Contract Ready? ',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  assetSendToOperationsConfirmation: {
    title: '',
    message: '<i class="fa fa-lg fa-info text-info mr-1 align-middle"></i> ' +
    ' Do you want to send these assets to Operations? ',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  assetMoveToRelistedConfirmation: {
    title: '',
    message: '<i class="fa fa-lg fa-info text-info mr-1 align-middle"></i> ' +
      ' It is not possible to move assets because some of them have been relisted ',
    okButtonText: 'OK'
  },
  contractMoveOppWithDifferentEventError: {
    title: '',
    message: '<i class="fa fa-lg fa-close text-danger mr-1 align-middle"></i> ' +
      ' Based on the current sale event, the asset cannot be sold in the selected sale event. ' +
      'Please choose a contract with a compatible sale event. ',
    okButtonText: 'OK'
  },
  confirmAssetPendingAppraisal: {
    title: '',
    message: '<i style="display: inline-flex" class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i>' +
      ' Asset(s) are receiving an appraisal inspection which is not yet complete. Inspection Services should be notified if you are moving to another contract\\opportunity or changing the Asset Origin address. Are you sure you want to proceed?',
    okButtonText: 'Yes',
    cancelButtonText: 'No'
  },
  movedCollapsedToInventoryAssetsError: {
    title: '',
    message: '<div class="alert alert-warning text-body"><i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
      ' Move to Other Contract should only be used to correct where the asset has sold on the wrong contract. Please use Resell button to put a collapsed asset back up for sale. ' + '</div>',
    okButtonText: 'Dismiss'
  },
  movedCollapsedToSellerAssetsOnRiskContract: {
    title: '',
    message: '<div class="alert alert-warning text-body"><i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
      ' Move to Other Contract should only be used to correct where the asset has sold on the wrong contract within the same event. Please use Other Event/Channel button to put a collapsed asset back up for sale at a future event on this contract or a new contract. ' + '</div>',
    okButtonText: 'Dismiss'
  },
  movedCollapsedToSellerAssetsOnInventoryContract: {
    title: '',
    message: '<div class="alert alert-warning text-body"><i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
      ' Move to Other Contract should only be used to correct where the asset has sold on the wrong contract within the same event. Please use Other Event/Channel button to put a collapsed asset back up for sale at a future event and will require a new contract. ' + '</div>',
    okButtonText: 'Dismiss'
  },
  movedMultipleCollapsedAssets: {
    title: '',
    message: '<div class="alert alert-warning text-body"><i class="fa fa-lg fa-warning text-warning mr-1 align-middle"></i> ' +
      ' Move to Other Contract should only be used to correct where the asset has sold on the wrong contract within the same event. ' + '</div>',
    okButtonText: 'Dismiss'
  }
}

